/*
 * @Author: clive.cao
 * @Date: 2020-09-01 09:45:27
 * @LastEditTime: 2021-07-16 14:28:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nvoicep-h5/src/directive/v-input-length.js
 */
/**
 * 定义vue指令
 */
const close = require('@assets/img/app/cleartext@2x.png')
let isKeyUp = false;
export default {
  install(Vue) {
    //使用v-input-length ，
    Vue.directive('inputClear', {
    
      binding (el, binding, vnode) {
        console.log('el,binding,vnode')
      },
      inserted (el,binding) {
        el.addEventListener('keyup',function(){
          isKeyUp = true
          const childNodesLength = el.parentNode.childNodes.length;
          if(childNodesLength == 3 || childNodesLength == 5){
            let img = document.createElement("img")
            img.src = close;
            img.style.cssText='position:absolute;width:16px;height:16px;top:50%;transform: translate(0,-50%)';
            img.addEventListener('click', function(){
              el.value = ''
              el.dispatchEvent(new Event('input')) // 派发事件
              el.parentNode.removeChild(img)
            });
            el.parentNode.append(img);
          }
          if(el.value.trim() === ''){
            el.parentNode.childNodes.forEach(e=>{
              if(e.nodeName === "IMG") el.parentNode.removeChild(e)
            })
          }
        },false)
      },
      update(el,binding) {
        const childNodesLength = el.parentNode.childNodes.length;
        // if((childNodesLength == 3 || childNodesLength == 5) && !isKeyUp){
        if((childNodesLength == 3 || childNodesLength == 5) && el.value.length){
          let img = document.createElement("img")
          img.src = close;
          img.style.cssText='position:absolute;width:16px;height:16px;top:50%;transform: translate(0,-50%)';
          img.addEventListener('click', function(){
            el.value = ''
            el.dispatchEvent(new Event('input')) // 派发事件
            el.parentNode.removeChild(img)
          });
          el.parentNode.append(img);
        }
      },
      unbind (el,binding) {
        // document.documentElement.style.backgroundColor = ''
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/directive/v-input-clear.js